import { Component, Input, OnInit, Output, EventEmitter } from '@angular/core';
import { NotifyService } from 'src/app/Services/notify.service';
import { RaiseBugService } from 'src/app/Services/raise-bug.service';

@Component({
  selector: 'ze-raise-bug',
  templateUrl: './raise-bug.component.html',
  styleUrls: ['./raise-bug.component.scss']
})
export class RaiseBugComponent implements OnInit {

  @Input() reportId!: string; // This receives the ID from parent
  @Output() bugSubmitted = new EventEmitter<void>(); 

  suites: any[] = [];
  features: any[] = [];
  scenarios: any[] = [];
  projectId: string | null = null;
  selectedSuite: string = '';
  selectedFeature: string = '';
  selectedScenario: string = '';
  description: string = '';
  noSuitesAvailable: boolean = false;
  noFeaturesAvailable: boolean = false;
  noScenarioAvailable: boolean = false;
  constructor(
    private bugService :RaiseBugService,
    private notifys: NotifyService
  ) { }

  ngOnInit() {
    this.projectId = localStorage.getItem('projectId');
    this.fetchSuites();
    this.fetchFeatures();
    this.fetchScenarios();
  }

  fetchSuites() {
    this.bugService.fetchSuites(this.projectId).subscribe({
    next: (res: any) => {
      if (res && Array.isArray(res.data) &&
          res.data.length > 0) {
        this.suites = res.data.map((suite: any) => ({
          id: suite._id,
          name: suite.name
        }));
         this.noSuitesAvailable = false;
      } else {
         this.noSuitesAvailable = true;
         this.suites = [];
      }
    },
     error: (err) => {
      this.noSuitesAvailable = true;
      this.suites = [];
    }
  });
  }

  fetchFeatures() {
    this.bugService.fetchFeature(this.projectId).subscribe({
    next: (res: any) => {
      if (res && Array.isArray(res.data) &&
          res.data.length > 0) {
        this.features = res.data.map((feature: any) => ({
          id: feature._id,
          name: feature.name
        }));
         this.noFeaturesAvailable = false;
      } else {
         this.noFeaturesAvailable = true;
         this.features = [];
      }
    },
     error: (err) => {
      this.noFeaturesAvailable = true;
      this.features = [];
    }
  });
  }

  fetchScenarios(){
    this.bugService.fetchScenario(this.projectId).subscribe({
    next: (res: any) => {
      if (res && Array.isArray(res.data) &&
          res.data.length > 0) {
        this.scenarios = res.data.map((scenario: any) => ({
          id: scenario._id,
          name: scenario.name
        }));
         this.noScenarioAvailable = false;
      } else {
         this.noScenarioAvailable = true;
         this.scenarios = [];
      }
    },
     error: (err) => {
      this.noScenarioAvailable = true;
      this.scenarios = [];
    }
  });
  }

  submitBug() {
    let payload ={
    "report_id":this.reportId,
    "projectId":this.projectId,
    "suiteId":this.selectedSuite,
    "featureId": this.selectedFeature,
    "scenarioId":this.selectedScenario,
    "description":this.description
    }    

    this.bugService.raiseBug(payload).subscribe({
    next: (res: any) => {
      if (res && res.operationStatus === 'SUCCESS') {
        this.selectedFeature='';
        this.selectedScenario='';
        this.selectedSuite='';
        this.description='';
        this.notifys.notify('success', 'Success', res.operationMessage);
        this.bugSubmitted.emit();
      }
    },
     error: (err) => {
     this.notifys.notify('error', 'Error', err.operationMessage);
    }
  });
}
}